const API_STACK = 'connect/';

export const GET_PARTICIPANTS = API_STACK + ':providerUuid' + '/participants';
export const POST_PARTICIPANT = GET_PARTICIPANTS;
export const GET_SINGLE_PARTICIPANT = GET_PARTICIPANTS + '/:participantUuid';
export const PATCH_PARTICIPANT = GET_SINGLE_PARTICIPANT;
export const DELETE_PARTICIPANT = GET_SINGLE_PARTICIPANT;
export const GET_NOTIFICATIONS = API_STACK + ':providerUuid' + '/notifications';
export const PATCH_NOTIFICATION = GET_NOTIFICATIONS + '/:notificationUuid';